import React from 'react';
import PanelMeasure from '@/layout/components/PanelMeasure';
import CataloguePanelFull from './CataloguePanelFull';
import CataloguePanelNarrow from './CataloguePanelNarrow';

const CataloguePanel = ({ configuration, onChange }) => (
  <PanelMeasure
    configuration={configuration}
    component={{ full: CataloguePanelFull, narrow: CataloguePanelNarrow }}
    onChange={onChange}
    width={620}
  />
);

export default CataloguePanel;
